export default __webpack_public_path__ + "static/media/benoit.5ddeee9c.jpeg";